import React from 'react'
import {Switch, Route, Redirect} from 'react-router'
// import Form from '../components/Form/Form'
// import Login from '../components/User/Login'
// import WaitingConfirm from '../components/User/WaitingConfirm'
import PrivacyTerm from '../components/PrivacyTerm/PrivacyTerm'

 export default () => 
     <Switch>
         {/* <Route path='/cadastrarpesqueiro' component={Form}/> */}
         <Route path='/termoprivacidade' component={PrivacyTerm}/>
         {/* <Route path='/login' component={Login}/>
         <Route path='/confirmaremail' component={WaitingConfirm}/> */}
         <Redirect from='*' to='/termoprivacidade'/>
     </Switch>